import { useEffect, useCallback } from 'react';
import window from '../window/index.js';

const fns = new Set();

export const loop = () => {
  for (const fn of fns.values()) {
    fn(window.data);
  }
};

export default function useResize(fn, deps = []) {
  const onResize = useCallback(fn, deps);

  useEffect(() => {
    fns.add(onResize);
    return () => fns.delete(onResize);
  }, [onResize]);
  
  useEffect(() => {
    onResize(window.data);
  }, []);
};